import type { FormEvent } from 'react';
import { Card } from '@shared/ui/Card';
import { Button } from '@shared/ui/Button';
import { Input, Label, Field } from '@shared/ui/Input';
import { Err, FileHint, Grid, ObjName, SubmitWrap } from '../styles';

export function UploadCheckCard({
  objectName,
  setObjectName,
  region,
  setRegion,
  setGpFiles,
  setSpFiles,
  uploading,
  can_write,
  uploadError,
  onUpload,
}: {
  objectName: string;
  setObjectName: (v: string) => void;
  region: string;
  setRegion: (v: string) => void;
  setGpFiles: (f: FileList | null) => void;
  setSpFiles: (f: FileList | null) => void;
  uploading: boolean;
  can_write: boolean;
  uploadError: string | null;
  onUpload: (e: FormEvent) => void;
}) {
  return (
    <Card>
      <form onSubmit={onUpload}>
        <ObjName>Загрузка пакетов сторон</ObjName>
        <Field>
          <Label>Наименование объекта (необязательно)</Label>
          <Input
            placeholder="Реконструкция установки…"
            value={objectName}
            onChange={(e) => setObjectName(e.target.value)}
          />
        </Field>
        <Grid>
          <Field>
            <Label>Сторона генподряда (gp)</Label>
            <Input
              type="file"
              accept=".xlsx,.xlsm"
              multiple
              onChange={(e) => setGpFiles(e.target.files)}
            />
            <FileHint>
              КС-2/КС-3 генподряда, договорная смета или ЛСР. Можно несколько файлов.
            </FileHint>
          </Field>
          <Field>
            <Label>Сторона субподряда (sp)</Label>
            <Input
              type="file"
              accept=".xlsx,.xlsm"
              multiple
              onChange={(e) => setSpFiles(e.target.files)}
            />
            <FileHint>КС-2/КС-3 субподрядчика или его выполнение. Можно несколько файлов.</FileHint>
          </Field>
        </Grid>
        <Field>
          <Label>Регион (необязательно)</Label>
          <Input
            placeholder="Тюменская область"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
          />
        </Field>
        {uploadError && <Err>{uploadError}</Err>}
        <SubmitWrap>
          <Button
            type="submit"
            $variant="primary"
            disabled={uploading || !can_write}
            title={!can_write ? 'Только чтение' : undefined}
          >
            {uploading ? 'Загрузка…' : 'Загрузить и сопоставить'}
          </Button>
        </SubmitWrap>
      </form>
    </Card>
  );
}
